import React from "react"
import "./Home.css"
import Header from "./Header"
import About from "./About"
import HomeVideo from "./HomeVideo"
import Teams from "./overview"
import Contact from "./Contact"
import Carousel from "./Carousel"
import Feeds from "./social-feeds"
import Testimonials from "../../Testimonials/Testimonials"

const Home = () => {
  return (
    <main className="home">
      <Header />
      <Carousel />
      <About />
      <HomeVideo />
      <Teams />
      <Feeds />
      <Contact />
      <Testimonials />
    </main>
  )
}

export default Home
